import React, { useEffect, useState } from "react";

function Pagination({ data = { meta: {} }, handlePageChange }) {
  const [nextPage, setNextPage] = useState("");
  const [prevPage, setPrevPage] = useState("");

  useEffect(() => {
    if (data?.meta?.prev_page_url != null) {
      var url = new URL(data?.meta?.prev_page_url);
      var searchParams = new URLSearchParams(url.search);
      var page = searchParams.get("page");
      setPrevPage(page);
    } else {
      setPrevPage("");
    }

    if (data?.meta?.next_page_url != null) {
      url = new URL(data?.meta?.next_page_url);
      searchParams = new URLSearchParams(url.search);
      page = searchParams.get("page");
      setNextPage(page);
    } else {
      setNextPage("");
    }
  }, [data]);

  return (
    <div className="sm:flex grid pagination items-center sm:justify-between justify-center">
      <div className="pagination-total text-center text-skin-base font-mulilight">
        Total <span>{data.meta.total_records}</span> Items
      </div>
      <div className="flex items-center">
        <span
          className={`border-[1px] border-solid border-skin-primary pagination-pager pagination-pager-next ${!prevPage ? "pagination-pager-inactive opacity-50 hover:cursor-default" : ""
            }`}
          onClick={() => {
            if (prevPage) {
              handlePageChange(prevPage);
            }
          }}
        >
          {/* <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth={0}
            viewBox="0 0 20 20"
            height="30px"
            width="30px"
            // fontFamily="Muli Light !important"
            // style={{ height: "30px !important", width: "30px !important" }}
            // fontFamily="Muli Light"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg> */}

          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-[22px] h-[22px]">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
          </svg>

        </span>
        <ul className="font-muliextralight">
          {Array.from({ length: data.meta.last_page }, (v, i) => i + 1).map(
            (pageNumber) => {
              if (
                pageNumber === 1 ||
                pageNumber === data.meta.last_page ||
                Math.abs(pageNumber - data.meta.current_page) <= 1
              ) {
                return (
                  <li
                    className={`font-muliextralight pagination-pager ${data.meta.current_page === pageNumber
                      ? "text-primary bg-muted"
                      : ""
                      } hover:bg-muted `}
                    key={pageNumber}
                    onClick={() => handlePageChange(pageNumber)}
                  >
                    {pageNumber}
                  </li>
                );
              } else if (
                pageNumber === data.meta.current_page - 2 ||
                pageNumber === data.meta.current_page + 2
              ) {
                return (
                  <li className="font-muliextralight pagination-pager pagination-pager-inactive">
                    <svg
                      stroke="currentColor"
                      fill="none"
                      strokeWidth={0}
                      viewBox="0 0 24 24"
                      height="1rem"
                      width="1rem"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
                      />
                    </svg>
                  </li>
                );
              } else {
                return <></>;
              }
            }
          )}
        </ul>
        <span
          className={`border-[1px] border-solid border-skin-primary pagination-pager pagination-pager-next ${!nextPage ? "pagination-pager-inactive opacity-50 hover:cursor-default" : ""
            }`}
          onClick={() => {
            if (nextPage) {
              handlePageChange(nextPage);
            }
          }}
        >
          {/* <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth={0}
            viewBox="0 0 20 20"
            height="1rem"
            width="1rem"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg> */}
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-[22px] h-[22px]">
            <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
          </svg>

        </span>
      </div>
      {/* </div> */}
    </div>
  );
}

export default Pagination;
